import { render, staticRenderFns } from "./registerStep5.vue?vue&type=template&id=0ba8b12c&scoped=true"
import script from "./registerStep5.vue?vue&type=script&lang=js"
export * from "./registerStep5.vue?vue&type=script&lang=js"
import style0 from "./registerStep5.vue?vue&type=style&index=0&id=0ba8b12c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba8b12c",
  null
  
)

export default component.exports